import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import emandateApi from "../services/emandate";
import {
    EMANDATE_RESPONSE, EMANDATE_RESPONSE_FAIL

} from '../redux/types/emandate';
let api = new emandateApi();


export function* emandate({ type, resolve, payload }) {
    let responsePayload = {};
    try {
        let { data } = yield api.emandate(payload);
        if (data?.success) {
            responsePayload = data;
            yield put({ type: EMANDATE_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        } else {
            resolve && resolve(data)
        }
    } catch (e) {
        yield put({ type: EMANDATE_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}
